import * as prismic from '@prismicio/client';

export const PRISMIC_REPOSITORY_NAME = 'palmettoblog';

export const client = prismic.createClient(PRISMIC_REPOSITORY_NAME, {
  accessToken: process.env.VITE_PRISMIC_ACCESS_TOKEN,
});
